import { render } from "./AllAds.vue?vue&type=template&id=1051cff0&scoped=true"
import script from "./AllAds.vue?vue&type=script&lang=js"
export * from "./AllAds.vue?vue&type=script&lang=js"

import "./AllAds.vue?vue&type=style&index=0&id=1051cff0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1051cff0"]])

export default __exports__